import { useTranslation } from "react-i18next";
import { Shield, Heart, Eye } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const ValuePillarsSection = () => {
  const { t } = useTranslation();

  const pillars = [
    {
      icon: Shield,
      titleKey: "valuePillars.pillars.compliance.title",
      descriptionKey: "valuePillars.pillars.compliance.description",
      iconColor: "text-primary",
      bgColor: "bg-primary/10"
    },
    {
      icon: Heart,
      titleKey: "valuePillars.pillars.experience.title",
      descriptionKey: "valuePillars.pillars.experience.description",
      iconColor: "text-destructive",
      bgColor: "bg-destructive/10"
    },
    {
      icon: Eye,
      titleKey: "valuePillars.pillars.control.title",
      descriptionKey: "valuePillars.pillars.control.description",
      iconColor: "text-blue-600",
      bgColor: "bg-blue-100"
    }
  ];

  return (
    <section className="py-20 px-4 bg-muted/30">
      <div className="container mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            {t('valuePillars.title')}
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {pillars.map((pillar, index) => (
            <Card key={index} className="border-0 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <CardContent className="pt-8 pb-6 px-6 text-center">
                <div className={`mx-auto w-16 h-16 ${pillar.bgColor} rounded-2xl flex items-center justify-center mb-6`}>
                  <pillar.icon className={`h-8 w-8 ${pillar.iconColor}`} />
                </div>
                <h3 className="font-bold text-xl mb-3 text-foreground">
                  {t(pillar.titleKey)}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {t(pillar.descriptionKey)}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuePillarsSection;
